import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useNavigate } from "react-router-dom";

const events = [
  { title: "Meeting", start: new Date(), id: " 00" },
  { title: "Meetingxx", start: new Date("2023-10-16"), id: " 001" },
  { title: "Msssssss ergg ery dr hd fyhrtdhyedthdthd ysdf hdf ssssssssssss sssssyhujyu", start: new Date("Mon Oct 17 2023 17:16:22 GMT+0530"), id: " 123" },
];

// a custom render function
function renderEventContent(eventInfo) {
  const btnDeleteHandle = () => {
    return console.log("Delete : ", eventInfo.event.id);
  };
  const btnEditHandle = () => {
    return console.log("Edit : ", eventInfo.event.id);
  };

  return (
    <div className=" py-1 px-2 mx-1 col-md-11 bg-gray-100	rounded border-1 border-slate-300	">
      <div className="row flex justify-between">
        <b className="col">{eventInfo.timeText}</b>
        <i className="col">{eventInfo.event.id}</i>
      </div>
      <div className="row ">
        <i className="col-md-11 overflow-ellipsis overflow-clip">{eventInfo.event.title}</i>
      </div>
      <div className="row">
        <i className="menu-icon tf-icons mdi mdi-delete text-rose-700 col" onClick={btnDeleteHandle}></i>
        <i className="menu-icon tf-icons mdi mdi-pencil text-green-800 col" onClick={btnEditHandle}></i>
      </div>
    </div>
  );
}
const EventCalendar = () => {
  const navigate = useNavigate();
  return (
    <>
      <Breadcrumb txt="Event Calendar" subpath={["Calendar"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">Calendar</h5>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                navigate("/addevent");
              }}
            >
              Add Event
            </button>
          </div>
          <div className="card-body">
            <FullCalendar plugins={[dayGridPlugin]} initialView="dayGridMonth" weekends={true} events={events} eventContent={renderEventContent} />
          </div>
        </div>
      </div>
    </>
  );
};

export default EventCalendar;
